import "./style.scss";
import { Product } from "../../types/Product";
import FormattedPrice from "../FormattedPrice";
import useShowPricesWithVat from "../../hooks/useShowPricesWithVat";
import { addVat } from "../../utils/VatUtils";
import { useProductTranslations } from "../../hooks/TranslationHooks";
import classNames from "classnames";

function SamplePriceArea({
  product,
  className
}: {
  product?: Product;
  className?: string;
}) {
  const tp = useProductTranslations();
  const showPricesWithVat = useShowPricesWithVat();
  const { sampleSaleable, samplePrice } = product ?? {};
  const basePrice = samplePrice?.basePrice ?? "0";

  return product && sampleSaleable ? (
    <div className={classNames("prices", className)}>
      <div className={"price"}>
        <FormattedPrice
          price_class_name={"big-price"}
          sales_unit={"sample"}
          price={showPricesWithVat ? addVat(basePrice) : basePrice}
          currency={samplePrice?.currency}
        />
      </div>
      <div className={"price-info"}>
        ({showPricesWithVat ? tp("price_incl_vat") : tp("price_excl_vat")})
      </div>
    </div>
  ) : null;
}

export default SamplePriceArea;
